(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', function() {
    initMegaMenuPosition();
    initMegaMenuHover();
    initMobileMenu();
    initSearchOverlay();
    initCollectionFilters();
    initCollectionFilterForm();
    initCollectionSort();
    initShowMore();
    initQuickAdd();
    initProductGallery();
    initSizeSelector();
    initLightbox();
    initSizeGuideModal();
    initProductRecommendations();
    initProductRecCarousels(document);
  });

  /* ========== MEGA MENU (full-width; --mega-menu-top from main header bottom) ========== */
  function initMegaMenuPosition() {
    var header = document.querySelector('.site-header');
    if (!header) return;

    function update() {
      var bottom = header.getBoundingClientRect().bottom;
      document.documentElement.style.setProperty('--mega-menu-top', Math.round(bottom) + 'px');
    }

    update();
    window.addEventListener('resize', update);
    window.addEventListener('scroll', update, { passive: true });
  }

  /**
   * Keeps the mega menu open while moving from the nav label into the fixed panel.
   * Fixed-position children can break pure CSS :hover across the gap; a delayed close
   * plus .is-mega-open matches the bridge hit-area in base.css.
   */
  function initMegaMenuHover() {
    var items = document.querySelectorAll('.header__nav-item[data-mega-menu]');
    if (!items.length) return;

    function closeAll(except) {
      items.forEach(function(el) {
        if (except && el === except) return;
        el.classList.remove('is-mega-open');
        var trigger = el.querySelector('[data-mega-trigger]');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      });
    }

    items.forEach(function(el) {
      var menu = el.querySelector('.mega-menu');
      var trigger = el.querySelector('[data-mega-trigger]');
      if (!menu) return;

      var closeTimer;

      function open() {
        clearTimeout(closeTimer);
        closeAll(el);
        el.classList.add('is-mega-open');
        if (trigger) trigger.setAttribute('aria-expanded', 'true');
      }

      function scheduleClose() {
        clearTimeout(closeTimer);
        closeTimer = window.setTimeout(function() {
          el.classList.remove('is-mega-open');
          if (trigger) trigger.setAttribute('aria-expanded', 'false');
        }, 280);
      }

      el.addEventListener('mouseenter', open);
      el.addEventListener('mouseleave', scheduleClose);
      menu.addEventListener('mouseenter', open);
      menu.addEventListener('mouseleave', scheduleClose);

      if (trigger) {
        trigger.addEventListener('click', function(e) {
          // First click opens mega menu on touch / keyboard; second follows link
          if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
            return;
          }
          if (!el.classList.contains('is-mega-open')) {
            e.preventDefault();
            open();
          }
        });
      }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeAll();
    });
  }

  /* ========== MOBILE MENU ========== */
  function initMobileMenu() {
    var menu = document.querySelector('.mobile-menu');
    var hamburger = document.querySelector('.header__hamburger');
    var closeBtn = document.querySelector('.mobile-menu__close');
    if (!menu || !hamburger) return;

    function open() {
      menu.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      menu.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    hamburger.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);

    menu.querySelectorAll('[data-has-submenu]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var li = btn.closest('.mobile-menu__nav-item');
        if (li) li.classList.toggle('is-open');
      });
    });
  }

  /* ========== SEARCH OVERLAY ========== */
  function initSearchOverlay() {
    var overlay = document.querySelector('[data-search-overlay]');
    if (!overlay) return;

    document.querySelectorAll('[data-search-toggle]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        overlay.classList.add('is-open');
        var input = overlay.querySelector('.search-overlay__input');
        if (input) input.focus();
      });
    });

    var closeBtn = overlay.querySelector('[data-search-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function() {
        overlay.classList.remove('is-open');
      });
    }

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) {
        overlay.classList.remove('is-open');
      }
    });
  }

  /* ========== COLLECTION FILTER DROPDOWNS ========== */
  function initCollectionFilters() {
    var dropdowns = document.querySelectorAll('[data-filter-dropdown]');
    if (!dropdowns.length) return;

    dropdowns.forEach(function(dropdown) {
      var toggle = dropdown.querySelector('[data-filter-toggle]');
      if (!toggle) return;

      toggle.addEventListener('click', function(e) {
        e.preventDefault();
        var wasOpen = dropdown.classList.contains('is-open');

        dropdowns.forEach(function(d) {
          d.classList.remove('is-open');
          var btn = d.querySelector('[data-filter-toggle]');
          if (btn) btn.setAttribute('aria-expanded', 'false');
        });

        if (!wasOpen) {
          dropdown.classList.add('is-open');
          toggle.setAttribute('aria-expanded', 'true');
        }
      });
    });

    document.addEventListener('click', function(e) {
      if (!e.target.closest('[data-filter-dropdown]')) {
        dropdowns.forEach(function(d) {
          d.classList.remove('is-open');
          var btn = d.querySelector('[data-filter-toggle]');
          if (btn) btn.setAttribute('aria-expanded', 'false');
        });
      }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        dropdowns.forEach(function(d) {
          d.classList.remove('is-open');
          var btn = d.querySelector('[data-filter-toggle]');
          if (btn) btn.setAttribute('aria-expanded', 'false');
        });
      }
    });
  }

  /* ========== COLLECTION FILTER FORM ========== */
  function initCollectionFilterForm() {
    var form = document.querySelector('[data-collection-filter-form]');
    if (!form) return;

    var isClearingFilterPanel = false;

    function applyFilters() {
      var params = new URLSearchParams();
      var formData = new FormData(form);
      for (var pair of formData.entries()) {
        if (pair[1] !== '' && pair[1] !== null) {
          params.append(pair[0], pair[1]);
        }
      }
      window.location.href = window.location.pathname + '?' + params.toString();
    }

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      applyFilters();
    });

    form.querySelectorAll('input[name="sort_by"]').forEach(function(radio) {
      radio.addEventListener('change', function() {
        applyFilters();
      });
    });

    form.addEventListener('change', function(e) {
      if (isClearingFilterPanel) return;
      var t = e.target;
      if (!t || !form.contains(t)) return;
      if (t.type === 'checkbox' && t.name && t.name.indexOf('filter.') === 0) {
        applyFilters();
        return;
      }
      if (t.type === 'number' && t.closest && t.closest('.filter-dropdown__price-range')) {
        applyFilters();
      }
    });

    form.querySelectorAll('[data-filter-clear]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var panel = btn.closest('[data-filter-dropdown]');
        if (panel) {
          isClearingFilterPanel = true;
          panel.querySelectorAll('input[type="checkbox"]').forEach(function(cb) {
            cb.checked = false;
          });
          isClearingFilterPanel = false;
        }
        applyFilters();
      });
    });

    form.querySelectorAll('[data-filter-search]').forEach(function(input) {
      input.addEventListener('input', function() {
        var query = this.value.toLowerCase();
        var list = this.closest('[data-filter-panel]').querySelector('[data-filter-list]');
        if (!list) return;
        list.querySelectorAll('[data-filter-item]').forEach(function(item) {
          var text = item.querySelector('[data-filter-text]');
          var match = !query || (text && text.textContent.toLowerCase().indexOf(query) !== -1);
          item.style.display = match ? '' : 'none';
        });
      });
    });
  }

  /* ========== COLLECTION SORT (minimal toolbar) ========== */
  function initCollectionSort() {
    var sortSelect = document.querySelector('[data-collection-sort]');
    if (!sortSelect) return;

    sortSelect.addEventListener('change', function() {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }

  /* ========== INFINITE SCROLL ========== */
  function initShowMore() {
    var sentinel = document.querySelector('[data-load-more-sentinel]');
    var grid = document.querySelector('[data-product-grid]');
    if (!sentinel || !grid) return;

    var progress = document.querySelector('[data-load-more-progress]');
    var status = document.querySelector('[data-load-more-status]');
    var loading = false;
    var done = false;
    var observer = null;
    var ROOT_MARGIN_PX = 400;

    function updateProgress(current, total) {
      if (!progress) return;
      var template = progress.getAttribute('data-template') || '';
      if (template.indexOf('__CURRENT__') !== -1) {
        progress.textContent = template
          .replace('__CURRENT__', String(current))
          .replace('__TOTAL__', String(total));
      } else {
        progress.textContent = "You've viewed " + current + ' out of ' + total + ' products';
      }
      progress.setAttribute('data-current', String(current));
      progress.setAttribute('data-total', String(total));
    }

    function sentinelInView() {
      if (!sentinel || !document.body.contains(sentinel)) return false;
      var rect = sentinel.getBoundingClientRect();
      return rect.top < window.innerHeight + ROOT_MARGIN_PX && rect.bottom > -ROOT_MARGIN_PX;
    }

    function finishInfiniteScroll() {
      done = true;
      if (sentinel) {
        sentinel.removeAttribute('data-next-url');
        sentinel.style.display = 'none';
      }
      if (observer) {
        observer.disconnect();
        observer = null;
      }
    }

    function loadNext() {
      if (loading || done) return;
      var nextUrl = sentinel.getAttribute('data-next-url');
      if (!nextUrl) {
        finishInfiniteScroll();
        return;
      }

      loading = true;
      if (status) status.hidden = false;

      fetch(nextUrl, { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error('load-more ' + r.status);
          return r.text();
        })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newCards = doc.querySelectorAll('[data-product-grid] .product-card');

          /* Bad HTML (password page / error) — keep sentinel so scroll can retry */
          if (!newCards.length) {
            throw new Error('load-more empty');
          }

          newCards.forEach(function (card) {
            grid.appendChild(document.importNode(card, true));
          });

          var newSentinel = doc.querySelector('[data-load-more-sentinel]');
          var next = newSentinel && newSentinel.getAttribute('data-next-url');
          if (next) {
            sentinel.setAttribute('data-next-url', next);
          } else {
            finishInfiniteScroll();
          }

          if (progress) {
            var total = parseInt(progress.getAttribute('data-total') || '0', 10);
            var current = parseInt(progress.getAttribute('data-current') || '0', 10) + newCards.length;
            if (!total) {
              var newProgress = doc.querySelector('[data-load-more-progress]');
              if (newProgress) total = parseInt(newProgress.getAttribute('data-total') || '0', 10);
            }
            updateProgress(current, total || current);
          }

          if (window.fixCurrency) window.fixCurrency();
        })
        .catch(function () {
          /* keep sentinel so user can scroll again to retry */
        })
        .finally(function () {
          loading = false;
          if (status) status.hidden = true;

          /*
            IntersectionObserver only fires on threshold *crossings*.
            After appending a page, the sentinel often stays in view, so no new
            event fires and loading stops at ~2 pages (e.g. 24+24=48).
            Keep fetching while it remains near the viewport.
          */
          if (!done && sentinelInView()) {
            loadNext();
          }
        });
    }

    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(
        function (entries) {
          if (entries.some(function (entry) { return entry.isIntersecting; })) {
            loadNext();
          }
        },
        { root: null, rootMargin: ROOT_MARGIN_PX + 'px 0px', threshold: 0 }
      );
      observer.observe(sentinel);
      if (sentinelInView()) loadNext();
    } else {
      window.addEventListener('scroll', function onScroll() {
        if (done) {
          window.removeEventListener('scroll', onScroll);
          return;
        }
        if (sentinelInView()) loadNext();
      });
      if (sentinelInView()) loadNext();
    }
  }

  /* ========== QUICK ADD TO CART ========== */
  function initQuickAdd() {
    document.body.addEventListener('click', function(e) {
      var btn = e.target.closest('.product-card__quick-bag');
      if (!btn || btn.disabled) return;

      e.preventDefault();
      e.stopPropagation();
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;

      var icon = btn.innerHTML;
      btn.innerHTML = '<span class="loading-spinner" style="width:14px;height:14px;"></span>';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        btn.innerHTML = icon;
        btn.disabled = false;
        if (window.CartDrawer) {
          window.CartDrawer.open();
        } else {
          updateCartCount();
        }
      })
      .catch(function() {
        btn.innerHTML = icon;
        btn.disabled = false;
      });
    });
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        document.querySelectorAll('.header__cart-count').forEach(function(el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
        if (window.fixCurrency) window.fixCurrency();
      });
  }

  /* ========== PRODUCT GALLERY ========== */
  function initProductGallery() {
    var main = document.querySelector('[data-gallery-main]');
    if (!main) return;

    var stage = main.querySelector('[data-gallery-stage]');
    var zoomHint = main.querySelector('[data-gallery-zoom-hint]');
    var thumbs = document.querySelectorAll('.product-gallery__thumb');
    var currentIndex = 0;

    function pauseVideos() {
      main.querySelectorAll('video').forEach(function(v) {
        try { v.pause(); } catch (e) {}
      });
    }

    function showMediaFromThumb(thumb) {
      if (!stage || !thumb) return;
      var type = thumb.getAttribute('data-media-type') || 'image';
      pauseVideos();

      if (type === 'video' || type === 'external_video') {
        var tpl = thumb.querySelector('template[data-media-html]');
        if (tpl) {
          stage.innerHTML = tpl.innerHTML;
        }
        main.classList.add('product-gallery__main--video');
        if (zoomHint) zoomHint.style.display = 'none';
        var vid = stage.querySelector('video');
        if (vid) {
          vid.muted = true;
          vid.play().catch(function() {});
        }
      } else {
        var fullSrc = thumb.getAttribute('data-full-src');
        var zoomSrc = thumb.getAttribute('data-zoom-src') || fullSrc || '';
        var thumbImg = thumb.querySelector('img');
        var alt = thumbImg ? thumbImg.getAttribute('alt') || '' : '';
        stage.innerHTML =
          '<img class="product-gallery__main-image" src="' + (fullSrc || '') +
          '" alt="' + alt.replace(/"/g, '&quot;') +
          '" data-zoom-src="' + zoomSrc +
          '" width="1400" height="1867" data-zoom-img>';
        main.classList.remove('product-gallery__main--video');
        if (zoomHint) zoomHint.style.display = '';
      }

      thumbs.forEach(function(t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    }

    thumbs.forEach(function(thumb, idx) {
      thumb.addEventListener('click', function() {
        currentIndex = idx;
        showMediaFromThumb(thumb);
      });
    });

    var prevArrow = document.querySelector('.product-gallery__nav-arrow--prev');
    var nextArrow = document.querySelector('.product-gallery__nav-arrow--next');

    if (prevArrow) {
      prevArrow.addEventListener('click', function(e) {
        e.stopPropagation();
        if (!thumbs.length) return;
        currentIndex = (currentIndex - 1 + thumbs.length) % thumbs.length;
        showMediaFromThumb(thumbs[currentIndex]);
      });
    }

    if (nextArrow) {
      nextArrow.addEventListener('click', function(e) {
        e.stopPropagation();
        if (!thumbs.length) return;
        currentIndex = (currentIndex + 1) % thumbs.length;
        showMediaFromThumb(thumbs[currentIndex]);
      });
    }

    var thumbTrack = document.querySelector('[data-thumb-track]');
    var thumbPrev = document.querySelector('.product-gallery__thumb-arrow--prev');
    var thumbNext = document.querySelector('.product-gallery__thumb-arrow--next');

    if (thumbTrack && thumbPrev && thumbNext) {
      var scrollAmt = 200;
      thumbPrev.addEventListener('click', function() {
        thumbTrack.scrollBy({ left: -scrollAmt, behavior: 'smooth' });
      });
      thumbNext.addEventListener('click', function() {
        thumbTrack.scrollBy({ left: scrollAmt, behavior: 'smooth' });
      });
    }

    if (main) {
      main.addEventListener('click', function(e) {
        if (e.target.closest('video, iframe, .product-gallery__nav-arrow, button')) return;
        if (main.classList.contains('product-gallery__main--video')) return;
        var thumb = thumbs[currentIndex];
        if (!thumb || thumb.getAttribute('data-media-type') !== 'image') return;
        var zoomSrc = thumb.getAttribute('data-zoom-src') || '';
        var imagesStr = main.getAttribute('data-images') || '';
        var images = imagesStr ? imagesStr.split('||') : [];
        var idx = images.indexOf(zoomSrc);
        if (idx < 0) idx = 0;
        openLightbox(idx);
      });
    }
  }

  /* ========== SIZE SELECTOR ========== */
  function initSizeSelector() {
    var dropdown = document.querySelector('[data-size-dropdown]');
    if (!dropdown) return;

    var trigger = dropdown.querySelector('[data-size-trigger]');
    var panel = dropdown.querySelector('[data-size-panel]');
    var label = dropdown.querySelector('[data-size-label]');
    var variantInput = document.querySelector('[data-variant-id-input]');
    var submitBtn = document.querySelector('.product-form__submit');

    if (trigger) {
      trigger.addEventListener('click', function() {
        dropdown.classList.toggle('is-open');
      });
    }

    dropdown.querySelectorAll('[data-size-option]').forEach(function(opt) {
      opt.addEventListener('click', function() {
        if (opt.disabled) return;

        var variantId = opt.getAttribute('data-variant-id');
        var isAvailable = opt.getAttribute('data-available') === 'true';
        var title = opt.querySelector('.size-dropdown__option-title');

        if (variantInput) variantInput.value = variantId;
        if (label && title) label.textContent = title.textContent;

        dropdown.querySelectorAll('[data-size-option]').forEach(function(o) {
          o.classList.remove('is-selected');
        });
        opt.classList.add('is-selected');

        /* Sync Add to Bag button to THIS variant's real availability —
           never blindly enable it, in case the selected size is sold out. */
        if (submitBtn) {
          submitBtn.disabled = !isAvailable;
          submitBtn.setAttribute('data-available', isAvailable);
          submitBtn.textContent = isAvailable
            ? (submitBtn.getAttribute('data-add-text') || submitBtn.textContent)
            : (submitBtn.getAttribute('data-sold-out-text') || 'SOLD OUT');
        }
        dropdown.classList.remove('is-open');
      });
    });

    document.addEventListener('click', function(e) {
      if (!e.target.closest('[data-size-dropdown]')) {
        dropdown.classList.remove('is-open');
      }
    });
  }

  /* ========== IMAGE LIGHTBOX ========== */
  var lightboxImages = [];
  var lightboxIndex = 0;
  var lightboxZoom = 1;
  var lightboxPanX = 0;
  var lightboxPanY = 0;
  var isDragging = false;
  var dragStartX = 0;
  var dragStartY = 0;

  function openLightbox(startIndex) {
    var galleryMain = document.querySelector('[data-gallery-main]');
    if (!galleryMain) return;

    var imagesStr = galleryMain.getAttribute('data-images');
    if (!imagesStr) return;

    lightboxImages = imagesStr.split('||');
    lightboxIndex = startIndex || 0;
    lightboxZoom = 1;
    lightboxPanX = 0;
    lightboxPanY = 0;

    var lightbox = document.querySelector('[data-lightbox]');
    if (!lightbox) return;

    lightbox.classList.add('is-open');
    document.body.style.overflow = 'hidden';

    buildLightboxThumbs();
    showLightboxImage();
  }

  function closeLightbox() {
    var lightbox = document.querySelector('[data-lightbox]');
    if (lightbox) lightbox.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function showLightboxImage() {
    var img = document.querySelector('[data-lightbox-img]');
    if (!img || !lightboxImages[lightboxIndex]) return;

    img.src = lightboxImages[lightboxIndex];
    lightboxZoom = 1;
    lightboxPanX = 0;
    lightboxPanY = 0;
    applyLightboxTransform();

    var wrap = document.querySelector('[data-lightbox-img-wrap]');
    if (wrap) wrap.classList.remove('is-zoomed');

    document.querySelectorAll('[data-lightbox-thumbs] .img-lightbox__thumb-btn').forEach(function(btn, i) {
      btn.classList.toggle('is-active', i === lightboxIndex);
    });
  }

  function applyLightboxTransform() {
    var img = document.querySelector('[data-lightbox-img]');
    if (img) {
      img.style.transform = 'scale(' + lightboxZoom + ') translate(' + lightboxPanX + 'px, ' + lightboxPanY + 'px)';
    }
    var wrap = document.querySelector('[data-lightbox-img-wrap]');
    if (wrap) wrap.classList.toggle('is-zoomed', lightboxZoom > 1);
  }

  function buildLightboxThumbs() {
    var container = document.querySelector('[data-lightbox-thumbs]');
    if (!container) return;

    container.innerHTML = '';
    lightboxImages.forEach(function(src, i) {
      var btn = document.createElement('button');
      btn.className = 'img-lightbox__thumb-btn' + (i === lightboxIndex ? ' is-active' : '');
      btn.innerHTML = '<img src="' + src.replace(/width:\d+/, 'width:200') + '" alt="">';
      btn.addEventListener('click', function() {
        lightboxIndex = i;
        showLightboxImage();
      });
      container.appendChild(btn);
    });
  }

  /* ========== SIZE GUIDE MODAL ========== */
  function initSizeGuideModal() {
    var modal = document.querySelector('[data-size-guide-modal]');
    if (!modal) return;

    function openModal(e) {
      if (e) e.preventDefault();
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('size-guide-modal-open');
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('size-guide-modal-open');
    }

    document.querySelectorAll('[data-size-guide-open]').forEach(function (btn) {
      btn.addEventListener('click', openModal);
    });

    modal.querySelectorAll('[data-size-guide-close]').forEach(function (el) {
      el.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });
  }

  function initLightbox() {
    var closeBtn = document.querySelector('[data-lightbox-close]');
    if (closeBtn) closeBtn.addEventListener('click', closeLightbox);

    var prevBtn = document.querySelector('[data-lightbox-prev]');
    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        lightboxIndex = (lightboxIndex - 1 + lightboxImages.length) % lightboxImages.length;
        showLightboxImage();
      });
    }

    var nextBtn = document.querySelector('[data-lightbox-next]');
    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        lightboxIndex = (lightboxIndex + 1) % lightboxImages.length;
        showLightboxImage();
      });
    }

    var wrap = document.querySelector('[data-lightbox-img-wrap]');
    if (wrap) {
      wrap.addEventListener('wheel', function(e) {
        e.preventDefault();
        lightboxZoom += e.deltaY > 0 ? -0.2 : 0.2;
        lightboxZoom = Math.max(1, Math.min(5, lightboxZoom));
        if (lightboxZoom === 1) { lightboxPanX = 0; lightboxPanY = 0; }
        applyLightboxTransform();
      });

      wrap.addEventListener('dblclick', function() {
        if (lightboxZoom > 1) {
          lightboxZoom = 1;
          lightboxPanX = 0;
          lightboxPanY = 0;
        } else {
          lightboxZoom = 2.5;
        }
        applyLightboxTransform();
      });

      wrap.addEventListener('mousedown', function(e) {
        if (lightboxZoom <= 1) return;
        isDragging = true;
        dragStartX = e.clientX - lightboxPanX;
        dragStartY = e.clientY - lightboxPanY;
        e.preventDefault();
      });

      document.addEventListener('mousemove', function(e) {
        if (!isDragging) return;
        lightboxPanX = e.clientX - dragStartX;
        lightboxPanY = e.clientY - dragStartY;
        applyLightboxTransform();
      });

      document.addEventListener('mouseup', function() { isDragging = false; });

      var touchStartX, touchStartY, lastTouchDist;
      wrap.addEventListener('touchstart', function(e) {
        if (e.touches.length === 1 && lightboxZoom > 1) {
          isDragging = true;
          dragStartX = e.touches[0].clientX - lightboxPanX;
          dragStartY = e.touches[0].clientY - lightboxPanY;
        } else if (e.touches.length === 2) {
          lastTouchDist = Math.hypot(
            e.touches[0].clientX - e.touches[1].clientX,
            e.touches[0].clientY - e.touches[1].clientY
          );
        }
      }, { passive: true });

      wrap.addEventListener('touchmove', function(e) {
        if (e.touches.length === 1 && isDragging) {
          lightboxPanX = e.touches[0].clientX - dragStartX;
          lightboxPanY = e.touches[0].clientY - dragStartY;
          applyLightboxTransform();
        } else if (e.touches.length === 2) {
          var dist = Math.hypot(
            e.touches[0].clientX - e.touches[1].clientX,
            e.touches[0].clientY - e.touches[1].clientY
          );
          var delta = dist - lastTouchDist;
          lightboxZoom = Math.max(1, Math.min(5, lightboxZoom + delta * 0.005));
          lastTouchDist = dist;
          if (lightboxZoom === 1) { lightboxPanX = 0; lightboxPanY = 0; }
          applyLightboxTransform();
        }
      }, { passive: true });

      wrap.addEventListener('touchend', function() { isDragging = false; });
    }

    document.addEventListener('keydown', function(e) {
      var lightbox = document.querySelector('[data-lightbox]');
      if (!lightbox || !lightbox.classList.contains('is-open')) return;

      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') {
        lightboxIndex = (lightboxIndex - 1 + lightboxImages.length) % lightboxImages.length;
        showLightboxImage();
      }
      if (e.key === 'ArrowRight') {
        lightboxIndex = (lightboxIndex + 1) % lightboxImages.length;
        showLightboxImage();
      }
    });
  }

  /* ========== PRODUCT REC CAROUSELS (single row + arrows) ========== */
  function initProductRecCarousels(root) {
    root = root || document;
    root.querySelectorAll('[data-product-rec-carousel]').forEach(function(wrap) {
      if (wrap.getAttribute('data-rec-init') === '1') return;
      wrap.setAttribute('data-rec-init', '1');

      var track = wrap.querySelector('[data-product-rec-track]');
      var prev = wrap.querySelector('[data-product-rec-prev]');
      var next = wrap.querySelector('[data-product-rec-next]');
      if (!track || !prev || !next) return;

      function scrollStep(dir) {
        var card = track.querySelector('.product-card');
        var step = card ? card.getBoundingClientRect().width + 16 : Math.min(320, track.clientWidth * 0.85);
        track.scrollBy({ left: dir * step, behavior: 'smooth' });
      }

      prev.addEventListener('click', function() { scrollStep(-1); });
      next.addEventListener('click', function() { scrollStep(1); });

      function updateArrows() {
        var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth - 2);
        var scrollable = maxScroll > 8;
        var display = scrollable ? 'flex' : 'none';
        prev.style.display = display;
        next.style.display = display;
        if (!scrollable) return;
        var left = track.scrollLeft;
        prev.disabled = left <= 4;
        next.disabled = left >= maxScroll - 4;
        prev.style.opacity = left <= 4 ? '0.35' : '1';
        next.style.opacity = left >= maxScroll - 4 ? '0.35' : '1';
      }

      track.addEventListener('scroll', updateArrows);
      window.addEventListener('resize', function() { updateArrows(); });
      if (window.ResizeObserver) {
        var ro = new ResizeObserver(updateArrows);
        ro.observe(track);
      }
      setTimeout(updateArrows, 100);
    });
  }

  /* ========== PRODUCT RECOMMENDATIONS (AJAX) ========== */
  function initProductRecommendations() {
    var placeholders = document.querySelectorAll('#product-complementary-placeholder, #product-related-placeholder');
    placeholders.forEach(function(el) {
      var productId = el.getAttribute('data-product-id');
      var sectionId = el.getAttribute('data-section-id');
      var intent = el.getAttribute('data-intent');
      var limit = el.getAttribute('data-limit') || 4;
      if (!productId || !sectionId) return;

      var url = '/recommendations/products?product_id=' + productId +
                '&section_id=' + sectionId +
                '&intent=' + intent +
                '&limit=' + limit;

      fetch(url)
        .then(function(r) { return r.text(); })
        .then(function(html) {
          el.innerHTML = html;
          if (window.fixCurrency) window.fixCurrency();
          initProductRecCarousels(el);
        })
        .catch(function(err) {
          console.error('Recommendations load error:', err);
        });
    });
  }

  /* ========== PRODUCT FORM SUBMIT ========== */
  document.addEventListener('submit', function(e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;

    e.preventDefault();
    var btn = form.querySelector('.product-form__submit');
    if (!btn || btn.disabled) return;

    var originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';

    var variantId = form.querySelector('[data-variant-id-input]').value;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      btn.textContent = 'Added!';
      if (window.CartDrawer) {
        window.CartDrawer.open();
      } else {
        updateCartCount();
      }
      setTimeout(function() {
        btn.disabled = false;
        btn.textContent = originalText;
      }, 1500);
    })
    .catch(function() {
      btn.disabled = false;
      btn.textContent = originalText;
    });
  });

})();
